import { render } from "./SurveyInputPostalCode.vue?vue&type=template&id=5e2f8c0c&ts=true"
import script from "./SurveyInputPostalCode.vue?vue&type=script&lang=ts"
export * from "./SurveyInputPostalCode.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__